import styled from '@emotion/styled'

// Eyebrow — small monospace label used above section headings to set context.
// Common pattern in the deck: an uppercase tracking label above a serif H1.
export const Eyebrow = styled.span`
  font-family: var(--font-mono);
  font-size: var(--t-eyebrow);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--c-fg-subtle);
`
